import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit')({
  beforeLoad: () => getTitleContextSlice('Audit'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
